export default function addAssignmentFilters(self, fields) {
  // We don't have a glossary of terms
  if (!self.glossary) {
    return;
  }

  const assignmentDefinition = self.glossary["assignment"];

  if (!assignmentDefinition) {
    return;
  }

  const AssignmentFields = {
    title: `Roster - Assignments`,
    minimum: 1,
    maximum: 1,
    key: "join_assignment",
    asObject: true,
    type: "group",
    fields: [
      {
        title: ``,
        minimum: 1,
        maximum: 1,
        key: "assignment",
        asObject: true,
        type: "group",
        fields: [
          {
            title: "Total",
            minimum: 1,
            maximum: 1,
            key: "total",
            type: "integer",
            referenceType: assignmentDefinition.key,
          },
        ],
      },
    ],
  };

  fields.push(AssignmentFields);
}
